import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccessoryInfoContainer from '../../containers/accessory-info-container';
import AccessoryInfoItem from '../../blocks/accessory-info-item';

const AccessoryInfoContainerBlock = props => <AccessoryInfoContainer {...props} />;
AccessoryInfoContainerBlock.displayName = 'AccessoryInfoContainer';

export default withDynamicComponents({
  componentWhitelist: [
    AccessoryInfoItem
  ],
  mapInputToOutput: [
    
  ],
})(AccessoryInfoContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/accessory-info-container/index.jsx